import { defaultStateType, typeAction } from '../typesStore'

const refresh = localStorage.getItem('refresh')
const access = localStorage.getItem('access')

const defaultState: defaultStateType = refresh
	? {
			access: access,
			refresh: refresh
	  }
	: {
			access: null,
			refresh: null
	  }

export default function (state = defaultState, action: typeAction) {
	const { type, value } = action
	switch (type) {
		case 'LOGIN_SUCCESS':
			localStorage.setItem('refresh', value.refresh)
			return {
				...state,
				access: value.access,
				refresh: value.refresh
			}
		case 'LOGIN_FAIL':
			localStorage.removeItem('refresh')
			return {
				...state,
				access: null,
				refresh: null
			}
		case 'LOGOUT':
			localStorage.removeItem('refresh')
			window.location.href = '/'
			return {
				...state,
				access: null,
				refresh: null
			}
		default:
			return state
	}
}
